import dayjsImport from "./auth-service-tools36.js";

function isInRange(date, range) {
  const _range = [...range].sort((a, b) => a.getTime() - b.getTime());

  return dayjsImport(_range[0]).startOf("day").subtract(1, "ms").isBefore(date) && dayjsImport(_range[1]).endOf("day").add(1, "ms").isAfter(date);
}

export { isInRange };